export default "__VITE_ASSET__DghEkOqM__"